/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { paymentProcessRequestV4Schema } from './paymentProcessRequestV4Schema'
import { paymentProcessResultV4ApiResponseObjectV4Schema } from './paymentProcessResultV4ApiResponseObjectV4Schema'

export const paymentsProcessStatus200Schema =
  paymentProcessResultV4ApiResponseObjectV4Schema.describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )

export const paymentsProcessStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const paymentsProcessStatus404Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const paymentsProcessResponseSchema = paymentsProcessStatus200Schema

export const paymentsProcessErrorSchema = z.union([
  paymentsProcessStatus400Schema,
  paymentsProcessStatus404Schema,
])

export const paymentsProcessBodySchemaJsonPatchJson = paymentProcessRequestV4Schema
  .optional()
  .describe('The references the bank appended to the return URL.')

export const paymentsProcessBodySchemaJson = paymentProcessRequestV4Schema
  .optional()
  .describe('The references the bank appended to the return URL.')

export const paymentsProcessBodySchemaJson2 = paymentProcessRequestV4Schema
  .optional()
  .describe('The references the bank appended to the return URL.')

export const paymentsProcessBodySchemaJson3 = paymentProcessRequestV4Schema
  .optional()
  .describe('The references the bank appended to the return URL.')

export const paymentsProcessBodySchema = z.union([
  paymentsProcessBodySchemaJsonPatchJson,
  paymentsProcessBodySchemaJson,
  paymentsProcessBodySchemaJson2,
  paymentsProcessBodySchemaJson3,
])
